const map = {
  // 退港
  transferList: () => import('@/views/shutout/transferList')
}

export default map
